import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import handleKeyPress from '../../common/handleKeyPress';
import * as Styled from './styles';

export default class PlayButtonColorSelect extends PureComponent {
    state = {
        selected: 0,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            ...prevState,
            selected: nextProps.playButtonColor,
        };
    }

    styling = (ind) => {
        const { selected } = this.state;
        return {
            height: 28,
            width: 90,
            border: selected === ind ? '1px solid #0277BD' : 'none',
            color: '#1C1C1C',
            backgroundColor: selected === ind ? '#F3F8FC' : '#FFFFFF',
            outline: 'none',
        };
    };

    icon = (ind) => {
        const { selected } = this.state;
        const enabled = 'play_circle_filled_white';
        const disabled = 'play_circle_outline';
        if (selected === ind) {
            return enabled;
        }
        return disabled;
    };

    iconStyle = (ind) => {
        const { selected } = this.state;
        return {
            fontSize: 18,
            width: 18,
            color: selected === ind ? '#0277BD' : '#727273',
        };
    };

    onPlayButtonClick = (selected, value, onClick) => {
        if ((value === 'white' && selected === 0) || (value === 'black' && selected === 1)) {
            return;
        }
        this.setState({ selected: value === 'white' ? 0 : 1 });
        onClick(value);
    };

    render() {
        const { onClick } = this.props;
        const { selected } = this.state;
        return (
            <div style={{ marginBottom: 10 }} data-test-id="play-button-color-select">
                <Styled.PlayButton
                    type="button"
                    data-test-id="play-button-color-select-white"
                    isSelected={selected === 0}
                    onClick={() => this.onPlayButtonClick(selected, 'white', onClick)}
                    onKeyDown={(e) => handleKeyPress(e, () => this.onPlayButtonClick(selected, 'white', onClick))}
                    tabIndex={0}
                >
                    <span style={{ display: 'flex' }}>
                        <i
                            className="material-icons"
                            data-test-id="play-button-color-select-white-icon"
                            style={this.iconStyle(0)}
                        >
                            {' '}
                            {this.icon(0)}{' '}
                        </i>
                        <p style={{ margin: 2 }}>White</p>
                    </span>
                </Styled.PlayButton>
                <Styled.PlayButton
                    type="button"
                    data-test-id="play-button-color-select-black"
                    isSelected={selected === 1}
                    onClick={() => this.onPlayButtonClick(selected, 'black', onClick)}
                    onKeyDown={(e) => handleKeyPress(e, () => this.onPlayButtonClick(selected, 'black', onClick))}
                    tabIndex={0}
                >
                    <span style={{ display: 'flex' }}>
                        <i
                            className="material-icons"
                            data-test-id="play-button-color-select-black-icon"
                            style={this.iconStyle(1)}
                        >
                            {' '}
                            {this.icon(1)}{' '}
                        </i>
                        <p style={{ margin: 2 }}>Black</p>
                    </span>
                </Styled.PlayButton>
            </div>
        );
    }
}

PlayButtonColorSelect.propTypes = {
    onClick: PropTypes.func.isRequired,
    playButtonColor: PropTypes.number.isRequired,
};
